/**
 * Veeroute.Delivery
 * Veeroute Delivery API
 *
 * The version of the OpenAPI document: 3.15.183137
 * Contact: support@veeroute.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Penalty for violation of compatibility. 
 */
export interface CompatibilityPenaltyDelivery { 
    /**
     * Tag from list of [compatibilities](https://docs.veeroute.ru/#/lss/lastmile?id=compatibilities). 
     */
    tag: string;
    /**
     * Penalty for violation of compatibility for the specified tag. 
     */
    penalty: number;
}

